module.exports = __webpack_public_path__ + "static/mentor-anjuman-88d5065693b336255d9c6ab4ce277395.png";